export var RowType;
(function (RowType) {
    RowType["Open"] = "open";
    RowType["Closed"] = "closed";
})(RowType || (RowType = {}));
export default RowType;
